// The Default Landing Page editor can give the "caught you" page a background colour. There is no
// column for it, so it is stored as a short marker comment at the start of Tenancy.LandingPage
// (a varchar(4000)). The editor strips the marker before showing the HTML and adds it back on save;
// CaughtYou reads it to colour the page body. Anything else rendering the HTML ignores the comment.

const MARKER = /^\s*<!--landing-bg:(#[0-9a-f]{3}(?:[0-9a-f]{3})?)-->/i;
const HEX_COLOUR = /^#[0-9a-f]{3}(?:[0-9a-f]{3})?$/i;

export function isLandingPageColour(value) {
    return HEX_COLOUR.test(value || "");
}

export function readLandingPageBackground(stored) {
    const html = stored || "";
    const match = html.match(MARKER);
    if (!match) {
        return { backgroundColor: "", html };
    }
    return { backgroundColor: match[1].toLowerCase(), html: html.slice(match[0].length) };
}

export function writeLandingPageBackground(html, backgroundColor) {
    // Strip any marker already present so saving twice never stacks them.
    const content = readLandingPageBackground(html).html;
    return isLandingPageColour(backgroundColor) ? `<!--landing-bg:${backgroundColor.toLowerCase()}-->${content}` : content;
}
